import { render, staticRenderFns } from "./TreatmentTasks.vue?vue&type=template&id=5d8f4ce3&scoped=true&lang=pug"
import script from "./TreatmentTasks.vue?vue&type=script&lang=js"
export * from "./TreatmentTasks.vue?vue&type=script&lang=js"
import style0 from "./TreatmentTasks.vue?vue&type=style&index=0&id=5d8f4ce3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8f4ce3",
  null
  
)

export default component.exports